import { useMutation, useQueryClient } from "@tanstack/react-query";

import { changeCustomerPreferredRate } from "@krea/customer-features/store/current-loan-application/api";
import { CURRENT_LOAN_APPLICATION_STORE_KEY } from "@krea/customer-features/store/queryClient";

import { useGetCachedCurrentLoanApplication } from "./useGetCachedCurrentLoanApplication";

export const useChangeCustomerPreferredRate = (loanApplicationID: string) => {
  const queryClient = useQueryClient();

  const { data: currentLoanApplication } = useGetCachedCurrentLoanApplication();

  const customerPreferredRate = currentLoanApplication?.customerPreferredRate;
  const alternativeRate = currentLoanApplication?.alternativeRate;

  // const { customerPreferredRate, alternativeRate } = currentLoanApplication;

  return useMutation({
    mutationFn: () =>
      changeCustomerPreferredRate(loanApplicationID, alternativeRate!),
    onSuccess: () => {
      queryClient.setQueryData(
        [CURRENT_LOAN_APPLICATION_STORE_KEY, loanApplicationID],
        {
          ...currentLoanApplication,
          customerPreferredRate: alternativeRate,
          alternativeRate: customerPreferredRate,
        },
      );
    },
    onError: () => {
      console.error("Failed to update customer preferred rate");
    },
  });
};
